const experiences = [
  {
    id: 2,
    icon: 'fa-graduation-cap',
    title: 'B.S. in Computer Science | Minor in Mathematics',
    subtitle: 'University of Arkansas at Little Rock — Donaghey Scholar, Full Scholarship Recipient',
    description: 'Studied software engineering, computer architecture, operating systems, databases, and computation theory.',
    startDate: 'August 2019 - August 2022',
    iconColor: 'fa-graduation-cap'
  },
  {
    id: 1,
    icon: 'fa-database',
    title: 'Associate Data Developer',
    subtitle: 'One80 Intermediaries',
    description: 'Develops and maintains ETL pipelines using SQL SSIS and C#/.NET to migrate and transform data across insurance platforms. Writes T-SQL queries, stored procedures, and views, monitors SQL job health, and ensures the secure handling of sensitive PII/PHI data.',
    startDate: 'March 2025 - Present',
    iconColor: 'fa-database'
  },
  {
    id: 3,
    icon: 'fa-coffee',
    title: 'Shift Supervisor',
    subtitle: 'Starbucks',
    description: 'Led shift operations and coached a team to consistently deliver high-quality customer experiences. Developed communication, leadership, and conflict-resolution skills in a fast-paced environment.',
    startDate: 'June 2020 - June 2022',
    iconColor: 'fa-circle'
  },
  {
    id: 4,
    icon: 'fa-file',
    title: 'Records Management Intern',
    subtitle: 'Arkansas Department of Energy and Environment',
    description: 'Collaborated with divisions across AE&E to maintain a compliance document database, ensuring accurate preservation of historical and regulatory records.',
    startDate: 'Summer 2021',
    iconColor: 'fa-file'
  },
];

export default experiences;